import ApplicationController from './application_controller'
import consumer from '../channels/consumer'
import CableReady from 'cable_ready'

/* Givsum 3.0 vanilla-JS counterpart to auction_controller.js.
 *
 * auction_controller.js stays untouched (jQuery + isotope) because
 * auctions#catalog_show / #faqs still render the legacy grid pages and
 * depend on it. index_v3/show_v3/my_bids_v3 use plain Bootstrap tabs and
 * server-side filtering (see the inline script at the bottom of
 * index_v3.html.haml), so all this controller needs to do is apply the live
 * AuctionChannel updates BidReflex/CancelBidReflex broadcast and keep the
 * outbid indicator / bid highlight in sync — no isotope, no jQuery required.
 */
export default class extends ApplicationController {
  connect() {
    super.connect()

    const opportunityId = this.element.dataset.opportunityId
    if (!opportunityId) return

    // Apply state from THIS page load's own localStorage seed (see the inline script at
    // the bottom of show_v3/index_v3/my_bids_v3) immediately — otherwise the tab count
    // only ever updates once some live broadcast happens to arrive, not on initial render.
    refreshOutbidIndicator()
    updateMyBidsTabCount()

    consumer.subscriptions.create({ channel: 'AuctionChannel', opportunity_id: opportunityId }, {
      received: (data) => {
        if (data.cableReady) {
          CableReady.perform(data.operations)
          fixBidderIdFields()
        }
        refreshOutbidIndicator()
        updateMyBidsTabCount()
      },
    })

    // BidReflex/CancelBidReflex broadcast the viewer's fresh userBids list to
    // UserChannel (cable_ready[UserChannel].set_storage_item(...)), but nothing on
    // show_v3 previously subscribed to it — localStorage.userBids only refreshed on a
    // full reload. Without this, the My Bids tab count and outbid indicator go stale
    // the instant you place a bid from the item detail page.
    if (window.givsum_user_id) {
      consumer.subscriptions.create({ channel: 'UserChannel', user_id: window.givsum_user_id }, {
        received: (data) => {
          if (!data.cableReady) return
          CableReady.perform(data.operations)
          refreshOutbidIndicator()
          updateMyBidsTabCount()
        },
      })
    }
  }
}

function fixBidderIdFields() {
  if (!window.givsum_user_id) return
  document.querySelectorAll('input[name="bidder_id"]').forEach((field) => {
    if (!field.value || String(field.value) !== String(window.givsum_user_id)) {
      field.value = window.givsum_user_id
    }
  })
}

function refreshOutbidIndicator() {
  const indicator = document.getElementById('outbid_indicator')
  if (!indicator) return
  try {
    const myBids = JSON.parse(localStorage.getItem('userBids') || '[]')
    const hasOutbids = myBids.some((bid) => bid.winning_bid === false)
    indicator.classList.toggle('d-none', !hasOutbids)
  } catch (e) {
    // malformed localStorage, ignore
  }
}

function updateMyBidsTabCount() {
  const countEl = document.querySelector('#my-bids-tab .tab-count')
  if (!countEl) return
  try {
    const myBids = JSON.parse(localStorage.getItem('userBids') || '[]')
    countEl.textContent = `(${myBids.length})`
  } catch (e) {
    // malformed localStorage, ignore
  }
}
